<template>
  <transition name="fade">
    <div id="alert-container">
      <div :class="alertType">
        {{ message }}
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Alert',
  props: [
    'message',
    'type'
  ],
  computed: {
    alertType () {
      return 'alert ' + this.type;
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../../stylesheets/variables.scss";

  #alert-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    pointer-events: none;
  }

  .alert {
    border-style: solid;
    border-width: 1px ;
    border-radius: $radius;
    padding-top: $sp-margin-small;
    padding-bottom: $sp-margin-small;
    padding-left: $sp-margin-large;
    padding-right: $sp-margin-large;
    margin: 0.5rem auto 0px auto;
    position: relative;
    width: fit-content;
    max-width: 60%;
  }

  .error {
    color: darken( $error, 30% );
    background-color: transparentize(lighten( $error, 20% ), 0.05);
    border-color: transparentize(lighten( $error, 10% ), 0.05);
  }

  .warning {
    color: darken( $warning, 30% );
    background-color: transparentize(lighten( $warning, 20% ), 0.05);
    border-color: transparentize(lighten( $warning, 10% ), 0.05);
  }

  .success {
    color: darken( $success, 30% );
    background-color: transparentize(lighten( $success, 20% ), 0.05);
    border-color: transparentize(lighten( $success, 10% ), 0.05);
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 1s
  }

  .fade-enter,
  .fade-leave-to
  /* .fade-leave-active in <2.1.8 */ {
    opacity: 0
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/alert/Alert.vue